import { ApiResponse } from "../types/api";
import { http } from "./http";

export type UploadedFile = {
  imagePath: string;
  url?: string;
};

export const uploadFile = async (file: File): Promise<string> => {
  const formData = new FormData();
  formData.append("file", file);

  const { data } = await http.post<ApiResponse<{ url: string }>>("/file/upload", formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });

  if (!data.success || !data.data) throw new Error(data.error || "Upload file failed");
  return data.data.url;
};


export const getFileUrl = (filename: string): string => {
  return `${http.defaults.baseURL?.replace(/\/$/, "")}/file/${filename}`;
};

export const uploadMultiFile = async (files: File[]): Promise<UploadedFile[]> => {
  const formData = new FormData();
  files.forEach((f) => formData.append("files", f)); // ⚠️ key = files

  const { data } = await http.post<ApiResponse<UploadedFile[]>>(
    "/file/upload/multi",
    formData,
    {
      headers: { "Content-Type": "multipart/form-data" },
    }
  );

  if (!data.success || !data.data) {
    throw new Error(data.error || "Upload multiple files failed");
  }

  return data.data;
};
